import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import BloodtypeIcon from '@mui/icons-material/Bloodtype';
import AppleIcon from '@mui/icons-material/Apple';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import FitbitIcon from '@mui/icons-material/Fitbit';
import ListAltIcon from '@mui/icons-material/ListAlt';
import TuneIcon from '@mui/icons-material/Tune';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

const siteNavigation = {
  logo: {
    src: "/images/RhodiumRootLogoLong3.png",
    alt: "Logo",
    href: "/#",
    requiresLogin: false,
  },
  menuItems: [
    {
      title: "The Journey",
      href: "/#journey",
      requiresLogin: false,
      type: "section",
      icon: <DirectionsRunIcon/>,
    },
    {
      title: "Pulse Check",
      href: "/#pulse",
      requiresLogin: false,
      type: "section",
      icon: <MonitorHeartIcon />,
    },
    {
      title: "Nutrition",
      href: "/#nutrition",
      requiresLogin: false,
      type: "section",
      icon: <AppleIcon />,
    },
    {
      title: "Performance Tools",
      href: "/#performance",
      requiresLogin: false,
      type: "section",
      icon: <TrackChangesIcon/>,
    },
    {
      title: "Book Research",
      href: "/#research",
      requiresLogin: false,
      type: "section",
      icon: <AutoStoriesIcon/>,
    },
    {
      title: "Workouts",
      href: "/#workouts",
      requiresLogin: false,
      type: "section",
      icon: <FitnessCenterIcon />,
    },
    {
      title: "AI Prompts",
      href: "/#prompts",
      requiresLogin: false,
      type: "section",
      icon: <AutoAwesomeIcon/>,
    },
    {
      title: "Recipes",
      href: "/recipes",
      requiresLogin: false,
      icon: <ListAltIcon/>,
    },
    {
      title: "Rhodium Papers",
      href: "/papers",
      requiresLogin: false,
      icon: <LibraryBooksIcon/>,
    },
    {
      title: "Profile",
      href: "/profile",
      requiresLogin: true,
      icon: <ManageAccountsIcon/>,
    },
    {
      title: "Workout Gen (AI)",
      href: "/utilities/workout/generator",
      requiresLogin: true,
      icon: <FitbitIcon />,
    },
    {
      title: "Food Analyzer (AI)",
      href: "/utilities/food/analyzer",
      requiresLogin: true,
      icon: <LocalDiningIcon />,
    },
    {
      title: "Supplement Opt (AI)",
      href: "/utilities/supplements/optimizer",
      requiresLogin: true,
      icon: <TuneIcon />,
    },
    {
      title: "Biomarkers",
      href: "/biomarkers",
      requiresLogin: true,
      icon: <BloodtypeIcon />,
    },
  ],
};

export default siteNavigation;
